/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agb_Pricing_TitleInputs */

const en_agb_pricing_title = /** @type {(inputs: Agb_Pricing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Prices and Payment`)
};

const de_agb_pricing_title = /** @type {(inputs: Agb_Pricing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Preise und Zahlung`)
};

const fr_agb_pricing_title = /** @type {(inputs: Agb_Pricing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Prix et paiement`)
};

const es_agb_pricing_title = /** @type {(inputs: Agb_Pricing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Precios y pago`)
};

const it_agb_pricing_title = /** @type {(inputs: Agb_Pricing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Prezzi e pagamento`)
};

const nl_agb_pricing_title = /** @type {(inputs: Agb_Pricing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Prijzen en betaling`)
};

const pl_agb_pricing_title = /** @type {(inputs: Agb_Pricing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Ceny i płatności`)
};

const fi_agb_pricing_title = /** @type {(inputs: Agb_Pricing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Hinnat ja maksaminen`)
};

const da_agb_pricing_title = /** @type {(inputs: Agb_Pricing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Priser og betaling`)
};

const sv_agb_pricing_title = /** @type {(inputs: Agb_Pricing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5. Priser och betalning`)
};

/**
* | output |
* | --- |
* | "5. Prices and Payment" |
*
* @param {Agb_Pricing_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const agb_pricing_title = /** @type {((inputs?: Agb_Pricing_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agb_Pricing_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_agb_pricing_title(inputs)
	if (locale === "fr") return fr_agb_pricing_title(inputs)
	if (locale === "es") return es_agb_pricing_title(inputs)
	if (locale === "it") return it_agb_pricing_title(inputs)
	if (locale === "nl") return nl_agb_pricing_title(inputs)
	if (locale === "pl") return pl_agb_pricing_title(inputs)
	if (locale === "fi") return fi_agb_pricing_title(inputs)
	if (locale === "da") return da_agb_pricing_title(inputs)
	if (locale === "sv") return sv_agb_pricing_title(inputs)
	return en_agb_pricing_title(inputs)
});